<template>
  <div class="m-viewport" v-if="ready">

        <h1 class="logo"></h1>
 
        <Loading v-if="isLoading"></Loading>
        <!-- loading -->
        <user-info ref="user" :name="name" :aid="aid" :login="login" @modal_switch="modal_switch" @userinfo_update="userinfo_update"></user-info>
        <!-- /.userinfo -->

        <div class="m-cacha">
            <div class="title t-cacha"></div>

            <ul>
                <li @click="callTradeModal" data-cid="1">
                    <div class="card"><img src="https://web-resource.17m3.com/m3guo/202109/kdcard/images/cover-1.png" alt="" srcset=""></div>
                    <div class="cnt" v-html="cardInfo[0]"></div>
                </li>
                <li @click="callTradeModal" data-cid="2">
                    <div class="card"><img src="https://web-resource.17m3.com/m3guo/202109/kdcard/images/cover-2.png" alt="" srcset=""></div>
                    <div class="cnt" v-html="cardInfo[1]"></div>
                </li>
                <li @click="callTradeModal" data-cid="3">
                    <div class="card"><img src="https://web-resource.17m3.com/m3guo/202109/kdcard/images/cover-3.png" alt="" srcset=""></div>
                    <div class="cnt" v-html="cardInfo[2]"></div>
                </li>
                <li @click="callTradeModal" data-cid="4">
                    <div class="card"><img src="https://web-resource.17m3.com/m3guo/202109/kdcard/images/cover-4.png" alt="" srcset=""></div>
                    <div class="cnt" v-html="cardInfo[3]"></div>
                </li>
                <li @click="callTradeModal" data-cid="5">
                    <div class="card"><img src="https://web-resource.17m3.com/m3guo/202109/kdcard/images/cover-5.png" alt="" srcset=""></div>
                    <div class="cnt" v-html="cardInfo[4]"></div>
                </li>
            </ul>

            <div class="u-btn draw" @click="cardDraw"></div>
        </div>
        <!-- /.cacha -->

        <div class="m-reward-view">
            <div class="title t-reward"></div>

            <ul>
                <li v-for="(item,index) in pack_config" :key="index">
                    <div class="reward-item" @click="$item_tips(item.id)">
                        <game-item :id="item.id" :num="item.num" :locked="true"></game-item>
                    </div>
                </li>
            </ul>
            
            <div class="u-btn apply disabled" v-if="reward == 8 || reward == 9 || reward == 7"></div>
            <div class="u-btn apply" v-else @click="giftApply"></div>
        </div>
        <!-- /.m-reward-view -->

        <div class="m-best-view">
            <div class="title t-best"></div>
            <div class="swiper">
                <swiper ref="swiper" :options="swiperOptions">
                    <swiper-slide><div class="best-img"><img :src="require('@/assets/images/gold.png')" alt=""></div></swiper-slide>
                    <swiper-slide><div class="best-img"><img :src="require('@/assets/images/gold.jpg')" alt=""></div></swiper-slide>
                </swiper>
                <!-- <div class="swiper-pagination" slot="pagination"></div> -->
                <div class="button-prev"></div>
                <div class="button-next"></div>
            </div>            
            
            <div class="ctrl">
                <div class="u-btn adress" @click="adressApply" :class="reward == 8?'act':'disabled'"></div>
                <div class="u-btn link" v-if="reward > 0"><a href="https://t.jifenfu.net/aWeoaz" target="_blank" rel="noopener noreferrer"></a></div>
                <div class="u-btn link disabled" v-else @click="$toast.info('请集齐五张卡牌后，再来领取奖励。')"></div>
            </div>
            
        </div>

        <item-tips ref="tips"></item-tips>

        <oshirase ref="msg" :show="oshirase_trriger" :reward="reward"></oshirase>
        <area-modal ref="area" :area_modal_trriger="area_modal_trriger" @modal_switch="modal_switch" :from_type="accout_type" @userinfo_update="userinfo_update"></area-modal>
        <draw-modal ref="draw" :draw_modal_trriger="draw_modal_trriger" :code="code" @modal_switch="modal_switch" @cardinfo_update="cardinfo_update"></draw-modal>
        <adress-modal ref="adress" :adress_modal_trriger="adress_modal_trriger" @modal_switch="modal_switch" @reward_update="reward_update"></adress-modal>
        <trade-modal ref="trade" :trade_modal_trriger="trade_modal_trriger" :trade_type="trade_type" :cid="cardclz" :cdk="key" :request="request" :text="text" @modal_switch="modal_switch" @cardinfo_update="cardinfo_update"></trade-modal>
  </div>
</template>

<script>
import GLOBAL from '@/assets/js/global.js'

import areaModal from '@/components/areaModal.vue';
import userInfo from '@/components/userInfo.vue';
import drawModal from '@/components/drawModal.vue';
import adressModal from '@/components/adressModal.vue';
import tradeModal from '@/components/cardTradeModal.vue';

//loading
import Loading from '@/components/loading/Loading.vue';

//login
import loginModal from '@/components/loginModal/index';

//oshirase
import oshiraseModal from '@/components/oshirase.vue';

export default {
  name: 'App',
  components: {
    'area-modal': areaModal,
    'draw-modal': drawModal,
    'user-info': userInfo,
    'adress-modal': adressModal,
    'trade-modal': tradeModal,
    'Loading' : Loading,
    'oshirase' : oshiraseModal,
  },
  data () {
    return {
        name: null,
        aid: 0,
        login: 0,
        reward: 0, //0-未达标, 1-达标未领取, 8-已领取未填地址, 9-已领取
        UA: {},
        token : '',
        code: '',
        key: '',
        type: '',
        ready : false,
        swiperOptions: {
            pagination: {
                el: '.swiper-pagination',    //与slot="pagination"处 class 一致
                clickable: true,            //轮播按钮支持点击
            },
            navigation:{
                nextEl: '.button-next',
                prevEl: '.button-prev',
            },
            autoplay : true,           
        },        
        draw_modal_trriger: false,
        adress_modal_trriger: false,
        trade_modal_trriger: false,
        area_modal_trriger: false,
        oshirase_trriger : false,
        isLoading: false,
        trade_type: '',
        accout_type: 1,
        cardclz: 0,
        cardInfo: [0, 0, 0, 0, 0],
        text: '',
        request: '',
        tips_trriger: false,
        tipsData: {},
        pack_config : [{id : 'LM47',name : '',num : 1},{id : 'D774',name : '',num : 3},{id : 'KR48',name : '',num : 10},{id : 'X230',name : '',num : 200},{id : 'X472',name : '',num : 20}],     
    }
  },
  mounted: function () {
        var _this = this;

        let token = GLOBAL.getQueryVariable('jwt') || localStorage.getItem("token");
        _this.code = GLOBAL.getQueryVariable('code') || localStorage.getItem("code");
        _this.trade_type = GLOBAL.getQueryVariable('trade_type') || localStorage.getItem("trade_type");
        _this.cardclz = GLOBAL.getQueryVariable('cardclz') || localStorage.getItem("cardclz");
        _this.key = GLOBAL.getQueryVariable('key') || localStorage.getItem("key");
        _this.request = GLOBAL.getQueryVariable('request') || localStorage.getItem("request");

        ['code', 'trade_type', 'cardclz', 'key', 'request'].map(item => localStorage.setItem(item, _this[item]));

        if (_this.key) {
            window.history.pushState({}, 0, GLOBAL.domain);
            _this.trade_type = 'send_comfirm';
        }

        if (_this.request) {
            window.history.pushState({}, 0, GLOBAL.domain);
            _this.trade_type = 'apply_comfirm';
        }

        if (token) {
            localStorage.setItem('token', token);
            window.history.pushState({}, 0, GLOBAL.domain);
            this.token = token;
            //GLOBAL.delUrlParam(document.location.href , 'jwt');
        }

        var instance = this.$axios.create();
        instance.defaults.timeout = 1000 * 10;

        /* 请求拦截 */
        this.$axios.interceptors.request.use(
            config => {
                //if(_this.isLoading)return;

                if (this.token != null) {
                    config.headers["Authorization"] = this.token;
                }

                if (config.method == 'post') {
                    //console.log(config);
                    //config.data = config.data || {};
                    config.url =  config.url.indexOf('?ver') > -1 ? config.url : config.url + '?ver=' + GLOBAL.version;
                } else if (config.method == 'get') {
                    config.params = config.params || {};
                    config.params.ver = GLOBAL.version;
                }

                _this.isLoading = true;
                return config;
            },
            err => Promise.reject(err)
        );

        //请求返回拦截
        this.$axios.interceptors.response.use((response) => {
            //402--未绑定
            _this.isLoading = false;
            if (response.data.code === 402) {
                _this.area_modal_trriger = true;
                //其余错误状态处理    
            } else if (response.data.code != 0) {
                //iView.Message.error(response.data.msg)
                //请求成功
            } else if (response.data.code === 0) {
                //将我们请求到的信息返回页面中请求的逻辑 

            }

            return response;

        }, function (error) {
            return Promise.reject(error);
        });

        function getCustomerInfo() {
            return new Promise((resolve, reject) => {
                _this.$axios.get(ajax_url_map.userinfo, {
                        params: {}
                    })
                    .then(function (response) {
                        //TODO
                        var UA = response.data;
                        if (response.data.code === 0) {
                            _this.login = 1;
                            _this.aid = UA.data.areaId;
                            _this.name = UA.data.name;
                            _this.reward = UA.data.reward;
                            resolve();
                        } else if (response.data.code === 402) {
                            _this.login = 1;
                            _this.name = UA.userInfo.uid.toString();
                            //resolve();
                        } else {
                            reject(response.data.message);
                        }

                        console.log(UA.userInfo.fromType);

                        if (_this.login) _this.accout_type = UA.userInfo.fromType;

                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            });
        }

        function KdFreeLogin(data) {
            data.id = 'kdwebjs';
            //TODO
            alert(JSON.stringify(data));
            return new Promise((resolve, reject) => {
                _this.$axios.get(ajax_url_map.free, {
                        params: data
                    })
                    .then(function (response) {
                        //TODO
                        alert(JSON.stringify(response.data));
                        var UA = response.data;
                        if (response.data.code === 0) {
                            token = response.data;
                            resolve();
                        } else {
                            reject(response.data.message);
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            });
        }

        function normalLogin() {
            getCustomerInfo()
                .then(
                    res => {
                        _this.$axios.get(_this.$global.ajax_url_map.cardInfo, {
                                params: {}
                            })
                            .then(function (response) {
                                if (response.data.code == 0) {
                                    //SET card
                                    var url = '';
                                    var code = ''
                                    for (var i = 0; i < response.data.data.length; i++) {
                                        var ai = response.data.data[i];
                                        var _index = ai.class;

                                        _this.$set(_this.cardInfo, _index - 1, (_this.cardInfo[_index - 1] + 1));
                                    }

                                    if (_this.trade_type) {
                                        url = _this.trade_type == "send_comfirm" ? GLOBAL.ajax_url_map.getShareInfo : GLOBAL.ajax_url_map.getRequestInfo;
                                        code = _this.trade_type == "send_comfirm" ? _this.key : _this.request;

                                        if (code != "null") queryCard(url, code);

                                    }
                                }
                            })
                            .catch(function (error) {
                                console.log(error);
                            });
                    },
                    rej => {
                        console.log(rej);
                    }
                );
        }

        function queryCard(url, code) {
            _this.$axios.get(url, {
                    params: {
                        key: code
                    }
                })
                .then(res => {
                    if (res.data.code == 0) {
                        _this.cardclz = res.data.data.class;
                        _this.cardTrade();
                    } else {
                        _this.$toast.info(res.data.message);
                    }
                })
        }

        // kd.config({
        //     id: 'kdwebjs',
        //     api: {
        //         freeLogin: GLOBAL.ajax_url_map.free + '?m=' + Math.random() // 后台验证接口地址，验证成功后，需根据传入的 uid 等信息实现自动登录
        //     }
        // });

        // // 调用免登录接口，进行免登录验证
        // kd.freeLogin(function (response, b, c) {
        //     //alert(JSON.stringify(response))
        //     if (typeof response !== 'undefined') {
        //         token = response.data;
        //     }
        //     normalLogin();
        // });
        this.get_user_info();
    },
    methods: {
      get_user_info() {
        // 调用免登录接口，进行免登录验证
        //TODO 梦平台免登录
        let _this = this;

        //alert(ajax_url_map.mplat);

        _this.Free_login.free_login_lazy(
          this.UA.uid, {
            mplat: ajax_url_map.mplat,
            kd: ajax_url_map.free,
          },
          function (response) {
            //alert(JSON.stringify(response))
            if (typeof response !== 'undefined') {
              _this.token = response.data ? response.data : response;
            }
            _this.update_evt();

          }
        );
      },
      update_login() {
        let _this = this;

        return new Promise((resolve, reject) => {
          _this.$axios.get(ajax_url_map.userinfo)
            .then(
              res => {
                console.log(res.data);
                if( res.data.code == 0 ){
                    _this.login = 1;
                    _this.UA = res.data;

                    _this.aid = _this.UA.data.areaId;
                    _this.name = _this.UA.data.name;
                    _this.reward = _this.UA.data.reward;

                    _this.accout_type = _this.UA.userInfo.fromType;

                    if(_this.reward > 0 && !_this.trade_type && !localStorage.getItem("oshirase")) _this.oshirase_trriger = true;

                }
                else if(res.data.code == 402 ){
                    _this.login = 1;
                    _this.UA = res.data;

                    _this.accout_type = _this.UA.userInfo.fromType;

                    console.log(_this.accout_type);
                }

                this.ready = true

                //console.log(_this.UA.userInfo.fromType);
                //if (_this.login) _this.accout_type = _this.UA.userInfo.fromType;
                
                resolve(res);
              },
              rej => {
                console.log(rej);
                this.ready = true
                //TODO share Warn
                //if(this.share)return this.$share_warn();
              }
            )
            .catch(function (error) {
              console.log(error);
            });
        });

      },
      update_evt() {
        let _this = this;

        async function _evt_init() {
          let _data = await _this.update_login();

        //   if (_data.code == 402) {
        //     _this.ready = true;
        //     _this.login = 1;
        //     _this.name = _this.UA.userInfo.uid.toString();
        //   }

          _this.$axios.post(ajax_url_map.cardInfo)
            .then(
              response => {
                if (response.data.code == 0) {
                    //SET card
                    var url = '';
                    var code = ''
                    for (var i = 0; i < response.data.data.length; i++) {
                        var ai = response.data.data[i];
                        var _index = ai.class;

                        _this.$set(_this.cardInfo, _index - 1, (_this.cardInfo[_index - 1] + 1));
                    }

                    if (_this.trade_type) {
                        url = _this.trade_type == "send_comfirm" ? ajax_url_map.getShareInfo : ajax_url_map.getRequestInfo;
                        code = _this.trade_type == "send_comfirm" ? _this.key : _this.request;

                        if (code != "null") _this.queryCard(url, code);
                    }
                }
              },
              rej => {
                _this.ready = true;
              }
            )
        }

          _evt_init();
        },
        queryCard (url, code) {
            let _this = this;
            _this.$axios.get(url, {
                    params: {
                        key: code
                    }
                })
                .then(res => {
                    if (res.data.code == 0) {
                        _this.cardclz = res.data.data.class;
                        _this.cardTrade();
                    } else {
                        _this.$toast.info(res.data.message);
                    }
                })
        },             
        cardDraw() {
            if (!this.login) return this.$mslogin.open();
            if (!this.aid) return this.area_modal_trriger = true;

            if (!this.code) return this.$toast.info('请尝试其他二维码~');

            document.body.addEventListener('touchmove', GLOBAL.bodyScroll, {
                passive: false
            });
            this.draw_modal_trriger = true;
        },
        adressApply() {

            let _this = this;
            if (!this.login) return this.$mslogin.open();
            if (!this.aid) return this.area_modal_trriger = true;

            if (this.reward < 8) return this.$toast.info('您未达成领奖条件~');
            if (this.reward == 9) return this.$toast.info('你已填写地址，请等待收货吧~');

            document.body.addEventListener('touchmove', GLOBAL.bodyScroll, {
                passive: false
            });
            this.adress_modal_trriger = true;
        },
        callTradeModal(e) {

            var _this = this;

            if (!this.login) return this.$mslogin.open();
            if (!this.aid) return this.area_modal_trriger = true;

            //TODO
            let _i = e.currentTarget.getAttribute('data-cid');
            let reserve = this.cardInfo[_i - 1];
            let url = reserve == 0 ? this.$global.ajax_url_map.request : this.$global.ajax_url_map.share;
            this.trade_type = reserve == 0 ? "apply" : "send";
            this.cardclz = _i;

            this.$axios.post(url + '?ver=' + GLOBAL.version, GLOBAL.param({
                    class: _i
                }))
                .then(function (response) {
                    if (response.data.code != 0) return _this.$toast.info(response.data.message);
                    _this.trade_modal_trriger = true;
                    _this.text = reserve == 0 ? GLOBAL.requestTxt[_i - 1] + response.data.data.content : GLOBAL.applyTxt[_i - 1] + response.data.data.content;
                    document.body.addEventListener('touchmove', GLOBAL.bodyScroll, {
                        passive: false
                    });
                });
        },
        modal_switch(key) {
            this[key] = !this[key];
        },
        userinfo_update(data) {
            this.aid = data.areaId;
            this.name = data.name;
            this.login = 1;
        },
        giftApply() {
            let _this = this;
            if (!this.login) return this.$mslogin.open();
            if (!this.aid) return this.area_modal_trriger = true;

            //if (this.reward == 0) return this.$toast.info('您未达成领奖条件~');
            if (this.reward == 9 || this.reward == 8) return this.$toast.info('奖励已领取~');

            this.$axios.get(this.$global.ajax_url_map.reward, {
                    params: {}
                })
                .then(function (response) {
                    if (response.data.code != 0) return _this.$toast.info(response.data.message || '请稍后再试');
                    _this.reward = response.data.data.gold ? 8 : 9;
                    _this.$toast.info('领取成功~');
                });
        },
        cardinfo_update(data) {
            this.cardInfo[data.class - 1] += data.cnt;
        },
        reward_update(val) {
            this.reward = val;
        },
        cardTrade() {
            this.trade_modal_trriger = true;
            document.body.addEventListener('touchmove', GLOBAL.bodyScroll, {
                passive: false
            });
        },
        itemTips(id) {
            this.tips_trriger = true;
        },
    },  
}
</script>

<style>
h1.logo{
    position: absolute;
    left: .3rem;
    top: .3rem;
    width: 1.02rem;
    height: .8rem;
    background-image: url(~@/assets/images/logo.png);
}
</style>



// WEBPACK FOOTER //
// src/App.vue